// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.w-notification-panel .v-list-item[data-v-661e8874] {\n  border-bottom: 1px solid rgba(255, 255, 255, 30%);\n  margin: 0 10px;\n  padding: 0 5px;\n}\n.w-notification-panel .v-list-item[data-v-661e8874]:last-child {\n  border-bottom: none;\n}\n.w-notification-panel .v-list-item .v-list-item__icon[data-v-661e8874] {\n  margin-right: 10px !important;\n}\n.notification-card-content[data-v-661e8874] {\n  max-height: 500px;\n  overflow-y: auto;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
